import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const restoreSession = useCallback(() => {
    const token = localStorage.getItem("perninhas_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => localStorage.removeItem("perninhas_token"))
      .finally(() => setChecking(false));
  }, []);

  useEffect(() => {
    restoreSession();
  }, [restoreSession]);

  const signIn = useCallback((payload) => {
    localStorage.setItem("perninhas_token", payload.token);
    setUser(payload.user);
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem("perninhas_token");
    setUser(null);
  }, []);

  const contextValue = useMemo(() => ({ user, setUser, checking, signIn, signOut }), [checking, signIn, signOut, user]);

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
